<template>
    <div>
        <a-modal :bodyStyle="{height:'260px'}" v-model="isVisible" title="开票申请" @ok="handleOk" @cancel="handleCancel">
            <div class="form-item">
                <span>发票抬头：</span>
                <!-- <a-input  v-model=“params.invoiceTitle” style="width:300px" /> -->
                <input class="modal__input" type="text" v-model="params.invoiceTitle">
            </div>
            <div class="form-item">
                <span>开票类型：</span>
                <a-radio-group v-model="params.invoiceType" @change="onChange">
                    <a-radio :value="1">增值税专用发票</a-radio>
                    <a-radio :value="2">增值税普票</a-radio>
                    <a-radio :value="86">电子普通发票</a-radio>
                </a-radio-group>
            </div>
            <div class="form-item">
                <span>开票类型：</span>
                <a-radio-group v-model="params.taxPayerType" @change="onChange">
                    <a-radio :value="0">一般纳税人</a-radio>
                    <a-radio :value="1">小规模纳税人</a-radio>
                </a-radio-group>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            value: 1,
            params:{
                invoiceType:1,
                taxPayerType:0,
                invoiceTitle:'',
                orderNo:''
            }
        };
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false
        },
        info:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    methods: {
        onChange(e) {
            console.log("radio checked", e.target.value);
        },
        async handleOk(e) {
            try{
                const r = await this.$api.common.applyInvoice(this.params)
                if(!r.result){
                    this.$message.error(r.message)
                }else{
                    this.$$message.info('操作成功')
                }
            }catch(e){

            }finally{
                this.$emit("close");
            }
        },
        handleCancel(e) {
            // e.preventDefault();
            this.$emit("close");
        }
    },
    mounted(){
        console.log(this.info)
        this.params.orderNo = this.info.orderNo
    }
    // updated(){
    //     this.visible = this.isVisible
    // },
    // mounted(){
    //     console.log(this.isVisible)

    // }
};
</script>

<style scoped>
.modal__input{
    border: 1px solid #999;
    border-radius: 5px;
    height: 30px;
}
.form-item{
    margin-top: 10px
}
</style>